<!--
 * @Author: 月魂
 * @Date: 2021-02-03 10:40:02
 * @LastEditTime: 2022-01-31 14:38:23
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\components\Footer.vue
-->
<template>
  <div class="footer">
    <div class="footer-menu">
      <div class="left fir">{{ $t("message.footer.left.title") }}</div>
      <div class="right">
        <div>{{ $t("message.footer.left.item1") }}</div>
        <div>{{ $t("message.footer.left.item2") }}</div>
      </div>
    </div>
    <!-- <div class="footer-menu">
      <div class="left">{{ $t("message.footer.right.title") }}</div>
      <div class="right">{{ $t("message.footer.right.item") }}</div>
    </div> -->
    <div class="footer-menu">
      <div class="left">{{ $t("message.footer.thanks.title") }}</div>
      <div class="right">{{ $t("message.footer.thanks.item") }}</div>
    </div>
    <div class="icon">
      <img src="../assets/qrcode1.jpg" alt="" class="img">
      <img src="../assets/qrcode2.jpg" alt="" class="img">
      <a
        href="https://twitter.com/visitshaanxi"
        target="_blank"
      >
        <img src="../assets/t.png" class="img link" />
      </a>
      <a
        href="https://www.facebook.com/visitshaanxi"
        target="_blank"
      >
        <img src="../assets/f.png" class="img link" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped lang="less">
.footer {
  background: #012545;
  padding: 16px 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .icon {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
    .img {
      display: block;
      width: 60px;
      margin-right: 16px;
    }
    .link {
      width: 30px;
    }
  }
  .footer-menu {
    width: 100%;
    color: #fff;
    display: flex;
    font-size: 14px;
    text-align: left;
    .left {
      line-height: 1.5;
      margin-right: 6px;
    }
    .fir {
      margin-right: 30px;
    }
    .right {
      display: flex;
      flex-wrap: wrap;
      line-height: 1.5;
      div {
        width: 100%;
      }
    }
    p {
      margin: 0;
      padding: 0;
      line-height: 24px;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
